// extracted by mini-css-extract-plugin
export var container = "_9b-0";
export var error = "_9b-9";
export var label = "_9b-5";
export var light = "_9b-6";
export var md = "_9b-3";
export var sm = "_9b-2";
export var thin = "_9b-8";
export var thinBold = "_9b-7";
export var vertical = "_9b-4";
export var xs = "_9b-1";